import { usePortfolioFlowLayout } from './PortfolioProcessLayoutManager';

export const usePortfolioFlowLayoutState = () => {
    const { state } = usePortfolioFlowLayout();

    return state;
};
